import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { map, take } from 'rxjs';
import { StoreAuthService } from '../services/store-auth.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const storeAuthService = inject(StoreAuthService);
  const router = inject(Router);

  return storeAuthService.getAuthToken().pipe(
    take(1), // Complete the observable after the first value is emitted
    map(isAuthenticated => {
      if (isAuthenticated) {
        return true;
      } else {
        router.navigate(['/login']); // Redirect to login if not authenticated
        return false;
      }
    })
  );

  // return true;
};
